export const LOAD_CATEGORY = '[assignDevices] load list of category';
export const PROCESS_CATEGORY = '[assignDevices] process list of category';
export const INSERT_CATEGORY = '[assignDevices] insert list of category';
export const CATEGORY_ERROR = '[assignDevices] error loading category';
export const LOAD_ASSIGNMENT_SUMMARY = '[assignDevices] load assignment summary';
export const PROCESS_ASSIGNMENT_SUMMARY = '[assignDevices] process assignment summary';
export const PROCESS_APPEND_ASSIGNMENT_SUMMARY = '[assignDevices] process append assignment summary';
export const INSERT_ASSIGNMENT_SUMMARY = '[assignDevices] insert assignment summary';
export const APPEND_ASSIGNMENT_SUMMARY = '[assignDevices] append to assignment summary';
export const ASSIGNMENT_ERROR = '[assignDevices] error loading assingment summary';
export const LOAD_UNMATCHED_DEVICES = '[assignDevices] load unmatched devices';
export const PROCESS_UNMATCHED_DEVICES = '[assignDevices] process unmatched devices';
export const PROCESS_APPEND_UNMATCHED_DEVICES = '[assignDevices] process append unmatched devices';
export const INSERT_UNMATCHED_DEVICES = '[assignDevices] insert unmatched devices';
export const APPEND_UNMATCHED_DEVICES = '[assignDevices] append to unmatched devices';
export const UNMATCHED_DEVICES_ERROR = '[assignDevices] error loading unmatched devices';
export const MAKE_DEVICE_ASSIGNMENT = '[assignDevices] make device assignment request';
export const MAKE_CONFLICT_ASSIGNMENT = '[assignDevices] make device assignment request(conflicts tab)';
export const PROCESS_DEVICE_ASSIGNMENT = '[assignDevices] process device assignment request';
export const PROCESS_CONFLICT_ASSIGNMENT = '[assignDevices] process device assignment request(conflicts tab)';
export const DEVICE_ASSIGNMENT_ERROR = '[assignDevices] error assigning devices';
export const CLEAR_EXISTING_ASSIGNMENTS = '[clear assignment] clear existing assignments';
export const CLEAR_ASSIGNMENT_ERROR = '[clear assignment] error clearing assignments';
export const PROCESS_CLEAR_EXISTING_ASSIGNMENTS = '[clear assignments] processing clear existing assignments';
export const INSERT_POST_CONFLICT_DEVICES = '[assignDevices] insert post conflicts devices';
export const CLEAR_POST_CONFLICT_DEVICES = '[assignDevices] clear post conflicts devices';
export const INSERT_POST_CONFLICT_USERCONFLICT_DEVICES = '[assignDevices] insert post conflicts devices for user conflict';
export const CLEAR_POST_CONFLICT_USERCONFLICT_DEVICES = '[assignDevices] clear post conflicts devices for user conflict';

export const loadCategoryDetails = () => ({
    type: LOAD_CATEGORY,
});

export const processCategoryDetails = (payload) => ({
    type: PROCESS_CATEGORY,
    payload,
});

export const insertCategoryDetails = (payload) => ({
    type: INSERT_CATEGORY,
    payload,
});

export const categoryError = (payload) => ({
    type: CATEGORY_ERROR,
    payload,
});

export const loadAssignmentSummary = (payload) => ({
    type: LOAD_ASSIGNMENT_SUMMARY,
    payload
});

export const processAssignmentSummary = (payload) => ({
    type: PROCESS_ASSIGNMENT_SUMMARY,
    payload,
});

export const processAppendAssignmentSummary = (payload) => ({
    type: PROCESS_APPEND_ASSIGNMENT_SUMMARY,
    payload,
});

export const insertAssignmentSummary = (payload) => ({
    type: INSERT_ASSIGNMENT_SUMMARY,
    payload,
});

export const appendAssignmentSummary = (payload) => ({
    type: APPEND_ASSIGNMENT_SUMMARY,
    payload,
});

export const assignmentError = (payload) => ({
    type: ASSIGNMENT_ERROR,
    payload,
});

export const loadUnmatchedDevices = (payload) => ({
    type: LOAD_UNMATCHED_DEVICES,
    payload
});

export const processUnmatchedDevices = (payload) => ({
    type: PROCESS_UNMATCHED_DEVICES,
    payload,
});

export const processAppendUnmatchedDevices = (payload) => ({
    type: PROCESS_APPEND_UNMATCHED_DEVICES,
    payload,
});

export const insertUnmatchedDevices = (payload) => ({
    type: INSERT_UNMATCHED_DEVICES,
    payload,
});

export const appendUnmatchedDevices = (payload) => ({
    type: APPEND_UNMATCHED_DEVICES,
    payload,
});

export const UnmatchedDevicesError = (payload) => ({
    type: UNMATCHED_DEVICES_ERROR,
    payload,
});

export const makeDeviceAssignmentRequest = (payload) => ({
    type: MAKE_DEVICE_ASSIGNMENT,
    payload,
});

export const insertPostConflictDevices = (payload) => ({
    type: INSERT_POST_CONFLICT_DEVICES,
    payload,
});

export const clearPostConflictDevices = () => ({
    type: CLEAR_POST_CONFLICT_DEVICES,
});

export const makeConflictAssignmentRequest = (payload) => ({
    type: MAKE_CONFLICT_ASSIGNMENT,
    payload,
});

export const insertPostConflictDevicesForConflictUsers = (payload) => ({
    type: INSERT_POST_CONFLICT_USERCONFLICT_DEVICES,
    payload,
});

export const clearPostConflictDevicesForConflictUsers = () => ({
    type: CLEAR_POST_CONFLICT_USERCONFLICT_DEVICES,
});

export const processDeviceAssignmentRequest = (payload) => ({
    type: PROCESS_DEVICE_ASSIGNMENT,
    payload,
});

export const processConflictAssignmentRequest = (payload) => ({
    type: PROCESS_CONFLICT_ASSIGNMENT,
    payload,
});

export const deviceAssignmentError = (payload) => ({
    type: DEVICE_ASSIGNMENT_ERROR,
    payload,
});

export const clearExistingAssignments = (payload) => ({
    type: CLEAR_EXISTING_ASSIGNMENTS,
    payload
});

// export const clearExistingUsrAssignments = (payload) => ({
//     type: CLEAR_EXISTING_USER_ASSIGNMENTS,
//     payload,
// });

// export const clearExistingUnitsAssignments = (payload) => ({
//     type: CLEAR_EXISTING_UNIT_ASSIGNMENTS,
//     payload,
// });

export const clearExistingAssignmentsError = (payload) => ({
    type: CLEAR_ASSIGNMENT_ERROR,
    payload,
});